/** Query-list chip — ListParamChip fed by live options (S10 cascading). */
import type { BoundParams, Dashboard, DashboardParameter } from '../../types/dashboardTypes';
import { ListParamChip } from './ListParamChip';
import { useParamOptions } from './useParamOptions';

type Props = {
  dashboard: Dashboard;
  def: Extract<DashboardParameter, { kind: 'query-list' }>;
  values: BoundParams;
  value: BoundParams[string] | undefined;
  onChange: (next: string | string[]) => void;
};

export function QueryListParamChip({ dashboard, def, values, value, onChange }: Props) {
  const { options, isLoading, error } = useParamOptions(dashboard.id, def, dashboard.parameters, values);
  return (
    <ListParamChip
      id={def.id}
      label={def.label}
      options={options}
      isLoading={isLoading}
      optionsError={error}
      multi={def.multi === true}
      includeAll={def.includeAll === true}
      defaultValue={def.defaultValue}
      value={value}
      onChange={onChange}
    />
  );
}
